// // /* @typedef {Object} Tab
// //  * @property {string | React.ReactNode} label - Tab label
// //  * @property {string} key - Tab key
// //  * @property {() => void} [handler] - Optional click handler
// //  * @property {boolean} [isDisabled] - Optional per-tab disable
// //  */
// // /* @typedef {("single" | "dual")} TabType
// //  * @property {string} type - Tab display type: "single" for single-line text, "dual" for multi-line text
// //  * @property {string} splitViewtype - Optional splitViewtype for style changes

import { useRef, useEffect, useState } from "react";
import PrimaryButton from "../PrimaryButton";

// CSS Import
import "./index.css";

// UTLIS Import
import { IntervalConfiguration } from "../../../../utils/configurationProvider";

const SwitcherTabs = ({
  tabs = [],
  initialActiveTab,
  isDisabled,
  type,
  swicherTabBgColor,
  splitViewtype,
  setIndex,
}) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab || tabs[0]?.key);
  const [textTransitionActive, setTextTransitionActive] = useState(false);
  const tabRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});

  useEffect(() => {
    let resizeTimeout;

    const updateIndicator = () => {
      const activeIndex = tabs.findIndex((tab) => tab.key === activeTab);
      const currentTab = tabRefs.current[activeIndex];

      if (currentTab) {
        setIndicatorStyle({
          width: currentTab.offsetWidth,
          height: currentTab.offsetHeight,
          top: type === "dual" ? "0" : currentTab.offsetTop,
          left: currentTab.offsetLeft,
          borderRadius: "var(--border-radius-md)",
        });
      }
    };

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateIndicator, 150);
    };

    updateIndicator();
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [activeTab, tabs, type]);

  useEffect(() => {
    if (initialActiveTab) {
      setActiveTab(initialActiveTab);
    }
    setTextTransitionActive(true);
  }, [initialActiveTab]);

  const handleTabClick = (tab) => {
    if (!tab.isDisabled) {
      tab.handler?.();
      setTimeout(() => {
        setActiveTab(tab.key);
        setTimeout(() => {
          setTextTransitionActive(true);
        }, IntervalConfiguration?.intervalSmaller);
        setTextTransitionActive(false);
      }, IntervalConfiguration?.intervalTiny);
    }
  };

  return (
    <div
      style={{
        width: "max-content",
        background: swicherTabBgColor
          ? swicherTabBgColor
          : "var(--primary-card)",
      }}
      className={` ${splitViewtype === "splitView" ? "px-padding-base" : "px-padding-xs"} relative flex  gap-gap-xs  rounded-border-radius-md 
      ${isDisabled ? "cursor-not-allowed opacity-light-opacity" : ""} ${type === "dual" ? "py-padding-xs" : "py-padding-xs "}`}
    >
      <div
        className="absolute bg-text-primary z-z-index-base transition-all duration-animation-medium ease-in-out"
        style={indicatorStyle}
      ></div>

      {tabs.map((tab, index) => {
        const isActive = activeTab === tab.key;

        return (
          <div
            key={tab.key}
            ref={(el) => (tabRefs.current[index] = el)}
            data-active={isActive}
            className={`relative  ${isActive ? "disable-hover" : ""
              } switcher-tab ${type === "dual" ? "switcher-tab-dual " : ""}`}
            style={{ flex: "1 0 auto" }}
          >
            <PrimaryButton
              btnText={tab.label}
              enabledBgColor={"transparent"}
              enabledTextColor={
                isActive && textTransitionActive
                  ? "var(--primary-card)"
                  : "var(--text-primary)"
              }
              handleFunction={() => {
                if (setIndex && !tab?.isDisabled) setIndex(index);
                handleTabClick(tab);
              }}
              isDisabled={tab.isDisabled || false}
              hoverOption="white"
              fullWidthRequired={true}
              // inActiveVariantNeeded={true}
              buttonRef={null}
              className={
                "whitespace-nowrap text-center overflow-hidden text-ellipsis transition-colors duration-200"
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default SwitcherTabs;
